import { Button, Modal, Form, Row, Col, Input, Select, message } from "antd";
import { useEffect, useState } from "react";
import fetchDataArps from "../../../../services/fetchDataArps";
import postDataArps from "../../../../services/postDataArps";

const { Option } = Select;

export default function CreateBudget({ isVisible, hideModal, refetch }: any) {
  const year = new Date().getFullYear();
  const [centers, setCenters] = useState<any>([]);

  const [form] = Form.useForm();

  const handleFetchCenters = async () => {
    const uri = "finance/centers";
    const response = await fetchDataArps(uri);
    setCenters(response.payload);
  };

  const onSubmit = async () => {
    const { center, opex_amount, capex_amount } = await form.validateFields();

    const data = {
      cost_center: center,
      year: year,
      opex_amount: opex_amount,
      capex_amount: capex_amount,
    };

    const uri = `finance/budget`;

    const response = await postDataArps(data, uri);

    if (response.success) {
      message.success("Created successfully");
      refetch();
    }
    hideModal();
  };

  const clearForm = async () => {
    form.resetFields();
  };

  const centerOptions = centers?.map((center: any, index: number) => (
    <Option value={center?.code} key={index}>
      {center?.name}
    </Option>
  ));

  useEffect(() => {
    handleFetchCenters();
  }, []);

  return (
    <Modal
      visible={isVisible}
      title={`Department Budget : ${year}`}
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="createBudget"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          danger
        >
          Create
        </Button>,
      ]}
    >
      <Form
        id="createBudget"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="center"
              label="Department / Cost Center"
              rules={[
                {
                  required: true,
                  message: "Please select denter name",
                },
              ]}
            >
              <Select placeholder="Department">{centerOptions}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="opex_amount"
              label="Operational Budget"
              initialValue={0}
              rules={[
                {
                  required: false,
                  message: "Please enter operational budget",
                },
              ]}
            >
              <Input type={"number"} placeholder="Opex Budget" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="capex_amount"
              label="Capital Budget"
              initialValue={0}
              rules={[
                {
                  required: false,
                  message: "Please enter capital budget",
                },
              ]}
            >
              <Input type={"number"} placeholder="Capex Budget" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
